"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CianMortgageBank = require("./CianMortgageBank");
Object.keys(_CianMortgageBank).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CianMortgageBank[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CianMortgageBank[key];
    }
  });
});